<template>
  <router-link :to="`/events/${data.id}`">
    <div class="home-event-item flex-col">
      <div
        class="cover"
        :style="`background:url(${data.cover_url}) no-repeat center center / cover`"
      ></div>
      <div class="home-title" v-text="data.topic"></div>
      <div class="pubtime" v-text="data.publish_time"></div>
    </div>
  </router-link>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "HomeEventBlock",
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup() {
    return {}
  }
});
</script>
<style lang="scss" scoped>
.home-event-item {
  width: 305px;
  height: 307px;
  background: #ffffff;
  border-radius: 5px;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0px 0px 20px 0px rgba(81, 85, 106, 0.13);
  }
  .cover {
    width: 305px;
    height: 174px;
    border-radius: 5px;
    object-fit: contain;
  }
  .home-title {
    width: 285px;
    height: 66px;
    font-size: 16px;
    font-weight: 600;
    color: #423e3d;
    line-height: 22px;
    overflow: hidden;
    margin: 20px 10px 10px;
  }
  .pubtime {
    height: 17px;
    font-size: 12px;
    color: #b1a9a7;
    line-height: 17px;
    padding: 0 10px;
  }
}
</style>

